(function($, Drupal, ServiceBus, Topics) {
  'use strict';
  
  if (window.self !== window.top) {
    return;
  }

  if (!ServiceBus || typeof ServiceBus.on !== 'function') {
    return;
  }

  if (!Topics.events || !Topics.events.FINDATION_BUTTON_CLICKED) {
    return;
  }

// Preload spinner image so it's cached.
  new Image().src = '/sites/esteelauder/themes/estee_base/img/ajax-loading.gif';

  let $activeLoadingButton = null;
  let isFirstClick = true;

  // Wait for React button to render, then inject hidden spinner.
  const buttonWaitSeconds = 10;
  const buttonCheckIntervalMs = 100;
  const buttonMaxAttempts = Math.ceil((buttonWaitSeconds * 1000) / buttonCheckIntervalMs);
  let buttonAttempts = 0;

  const buttonCheckInterval = setInterval(function() {
    buttonAttempts++;
    const $findationButton = $('.js-third-party-tout-findation-cta .js-mantle-cta-button');

    if ($findationButton.length > 0) {
      clearInterval(buttonCheckInterval);
      if ($findationButton.find('.findation-loading-spinner').length === 0) {
        $findationButton.prepend('<img class="findation-loading-spinner" src="/sites/esteelauder/themes/estee_base/img/ajax-loading.gif" style="position:absolute; left:50%; top:50%; width:32px; height:32px; margin:-16px 0 0 -16px;" alt="" aria-hidden="true">');
      }
    } else if (buttonAttempts >= buttonMaxAttempts) {
      clearInterval(buttonCheckInterval);
    }
  }, buttonCheckIntervalMs);

  ServiceBus.on(Topics.events.FINDATION_BUTTON_CLICKED,
    function(payload) {
      if (payload && isFirstClick && !$activeLoadingButton) {
        $activeLoadingButton = $('.js-third-party-tout-findation-cta .js-mantle-cta-button');
        $activeLoadingButton.addClass('is-loading').attr('aria-busy', 'true').attr('aria-disabled', 'true');

        const timeoutSeconds = 5;
        const checkIntervalMs = 100;
        const maxAttempts = Math.ceil((timeoutSeconds * 1000) / checkIntervalMs);
        let attempts = 0;

        const checkInterval = setInterval(function() {
          attempts++;
          const iframe = document.getElementById('findation-iframe');

          if (iframe) {
            clearInterval(checkInterval);

            const loadTimeoutSeconds = 30;
            const loadTimeout = setTimeout(function() {
              if ($activeLoadingButton) {
                $activeLoadingButton.removeClass('is-loading').removeAttr('aria-busy').removeAttr('aria-disabled');
                $activeLoadingButton = null;
              }
            }, loadTimeoutSeconds * 1000);
            
            $(iframe).on('load', function() {
              clearTimeout(loadTimeout);
              if ($activeLoadingButton) {
                $activeLoadingButton.removeClass('is-loading').removeAttr('aria-busy').removeAttr('aria-disabled');
                $activeLoadingButton = null;
                isFirstClick = false;
              }
            });
          } else if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
            if ($activeLoadingButton) {
              $activeLoadingButton.removeClass('is-loading').removeAttr('aria-busy').removeAttr('aria-disabled');
              $activeLoadingButton = null;
            }
          }
        }, checkIntervalMs);
      }
    }
  );

})(jQuery, Drupal, window.GlobalServiceBus || {}, window.ServiceBusTopics || {});
